import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { FaMapMarkedAlt, FaTimes, FaArrowRight, FaArrowLeft, FaCheck } from 'react-icons/fa';
const TooltipContainer = styled.div `
  background: #1a1a1a;
  border: 1px solid #3b82f6;
  border-radius: 8px;
  max-width: 420px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);
  overflow: hidden;
  /* Don't set position or z-index - those come from tooltipProps */
`;
const TooltipHeader = styled.div `
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;
const HeaderLeft = styled.div `
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
`;
const TourIcon = styled(FaMapMarkedAlt) `
  font-size: 18px;
  color: white;
`;
const HeaderTitle = styled.div `
  color: white;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;
const CloseButton = styled.button `
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    color: white;
    transform: scale(1.1);
  }

  svg {
    font-size: 16px;
  }
`;
const TooltipBody = styled.div `
  padding: 24px;
`;
const StepTitle = styled.h4 `
  color: white;
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 12px 0;
`;
const TooltipContent = styled.div `
  color: #d1d5db;
  font-size: 15px;
  line-height: 1.6;
  margin: 0;

  p {
    margin: 0 0 12px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    color: white;
    font-weight: 600;
  }

  code {
    background: rgba(59, 130, 246, 0.2);
    color: #60a5fa;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 14px;
    font-family: 'Courier New', monospace;
  }
`;
const TooltipFooter = styled.div `
  padding: 16px 24px;
  background: rgba(0, 0, 0, 0.3);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;
const StepIndicator = styled.div `
  color: #9ca3af;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
`;
const ButtonGroup = styled.div `
  display: flex;
  gap: 8px;
  align-items: center;
`;
const Button = styled.button.attrs({ type: 'button' }) `
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;

  ${props => props.$variant === 'primary' && `
    background: #3b82f6;
    color: white;
    border: 1px solid #3b82f6;

    &:hover {
      background: #2563eb;
      border-color: #2563eb;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
    }
  `}

  ${props => props.$variant === 'secondary' && `
    background: transparent;
    color: #9ca3af;
    border: 1px solid rgba(156, 163, 175, 0.3);

    &:hover {
      color: white;
      border-color: rgba(255, 255, 255, 0.3);
    }
  `}

  ${props => props.$variant === 'skip' && `
    background: transparent;
    color: #9ca3af;
    border: none;
    padding: 8px 12px;
    font-size: 13px;

    &:hover {
      color: white;
    }
  `}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
export const TourTooltip = ({ continuous, index, step, backProps, closeProps, primaryProps, skipProps, tooltipProps, isLastStep, size }) => {
    console.log('🎨 Tooltip Props:', tooltipProps);
    console.log('🎨 Close Props:', closeProps);
    return (_jsx("div", { ...tooltipProps, className: "custom-joyride-tooltip", children: _jsxs(TooltipContainer, { children: [_jsxs(TooltipHeader, { children: [_jsxs(HeaderLeft, { children: [_jsx(TourIcon, {}), _jsx(HeaderTitle, { children: "Feature Tour" })] }), _jsx(CloseButton, { onClick: (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                console.log('❌ Close button clicked - using skipProps to close tour');
                                if (skipProps?.onClick) {
                                    skipProps.onClick(e); // Use skipProps instead of closeProps!
                                }
                            }, type: "button", "aria-label": "Close tour", title: "Close tour", children: _jsx(FaTimes, {}) })] }), _jsxs(TooltipBody, { children: [step.title && _jsx(StepTitle, { children: step.title }), _jsx(TooltipContent, { children: typeof step.content === 'string' ? (_jsx("p", { children: step.content })) : (step.content) })] }), _jsxs(TooltipFooter, { children: [_jsxs(StepIndicator, { children: ["Step ", index + 1, " of ", size] }), _jsxs(ButtonGroup, { children: [index > 0 && (_jsxs(Button, { ...backProps, "$variant": "secondary", children: [_jsx(FaArrowLeft, {}), " Back"] })), continuous && (_jsx(Button, { ...primaryProps, "$variant": "primary", children: isLastStep ? (_jsxs(_Fragment, { children: [_jsx(FaCheck, {}), " Got it!"] })) : (_jsxs(_Fragment, { children: ["Next ", _jsx(FaArrowRight, {})] })) }))] })] })] }) }));
};
